<template>
  <Icon-Template :size="size">
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <path d="M463.702 162.655L442.491 14.164C440.747 1.99 425.784 -3.069 417.032 5.683L386.138 36.577C346.411 12.612 301.309 0 254.932 0C115.464 0 3.49074 109.16 0.00474479 248.511C-0.185255 256.128 5.35174 262.661 12.8807 263.745L72.8217 272.314C81.7577 273.618 90.0707 266.602 89.9467 257.256C88.7037 165.286 162.986 90 254.932 90C277.197 90 299.199 94.526 319.532 103.183L289.752 132.963C281.055 141.66 285.991 156.669 298.233 158.422L446.724 179.633C456.508 181.108 465.105 172.599 463.702 162.655Z"/>
      <path d="M499.117 249.412L439.22 240.857C431.482 239.877 422.096 246.508 422.096 257C422.096 347.981 348.077 422 257.096 422C234.948 422 213.048 417.518 192.79 408.948L221.618 380.12C230.315 371.423 225.379 356.414 213.137 354.661L64.6457 333.435C54.8927 332.042 46.2557 340.406 47.6677 350.413L68.8777 498.905C70.6237 511.092 85.5737 516.117 94.3367 507.386L125.978 475.76C165.514 499.505 210.587 512 257.096 512C395.89 512 507.848 403.382 511.993 264.72C512.213 257.088 506.676 250.496 499.117 249.412Z"/>
    </svg>
  </Icon-Template>
</template>

<script>

import IconTemplate from '@/components/icons/Template'

export default {
  props: ['size'],
  components: { IconTemplate }
}
</script>